import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';

@Component({
  selector: 'app-pdfa',
  templateUrl: './pdfa.component.html',
  styleUrls: ['./pdfa.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfaComponent {
  private loader = inject(DisbursmentService);
  isLoading$ = this.loader.loading$;

data = JSON.parse(sessionStorage.getItem("pa-success-response") || '{}');
  leftLongText = `Client: ${this.data?.client_name ?? ''}`;
  rightLongText = `Portagent: ${this.data?.port_agent_name ?? ''} `;
}
